import styled from 'styled-components';
import { Form } from 'formik';

export const Wrapper = styled.main`
    display: flex;
    height: 100vh;
    position: static;
`;

export const TextWrapper = styled.div`
    display: inline;
`;

export const CustomForm = styled(Form)`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 24px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    width: 100%;
    margin-top: 17px;
    gap: 5px;

    button {
        flex-basis: 100%;
    }

    ${({ theme }) => theme.media.md`
        gap: 20px;

        button {
            flex-basis: 50%;
        }
    `}
`;

export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 50px;

    label {
        margin-left: 5px;
    }

    a {
        color: ${({ theme }) => theme.colors.tertiary.tertiary50};
        font-weight: 500 !important;
    }
`;

export const ErrorBlock = styled.span`
    width: 100%;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.error.error50};
`;
